export default __webpack_public_path__ + "static/media/bundle-guide-us-white@3x.d71cf70a.webp";